import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Phone, MapPin, Mail, Instagram, 
   ArrowRight, 
  Trees, Shovel, ChevronRight,
  Clock, X 
} from 'lucide-react';

const Footer = () => {
  const [modalType, setModalType] = useState(null); // 'impressum', 'datenschutz' oder null

  const serviceCategories = [
    {
      title: "Pflege & Bäume",
      icon: <Trees className="w-5 h-5 text-emerald-500" />,
      items: ["baumfaellen", "gartenpflege", "heckenschneiden"]
    },
    {
      title: "Bau & Montage",
      icon: <Shovel className="w-5 h-5 text-emerald-500" />,
      items: ["holzterrassen", "pflastersteine", "zaunbau"]
    }
  ];

  const LegalModal = ({ title, isOpen, onClose, children }) => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm">
        <div className="bg-white text-slate-900 w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl shadow-2xl relative">
          <div className="sticky top-0 bg-white border-b border-slate-100 p-6 flex justify-between items-center">
            <h2 className="text-2xl font-semibold text-slate-800">{title}</h2>
            <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full transition-colors">
              <X size={24} />
            </button>
          </div>
          <div className="p-8 text-slate-700 leading-relaxed text-sm md:text-base">
            {children}
          </div>
          <div className="p-6 border-t border-slate-100 text-right">
            <button 
              onClick={onClose}
              className="bg-slate-900 text-white px-6 py-2 rounded-lg font-semibold hover:bg-emerald-700 transition-colors"
            >
              Schließen
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 border-t border-white/5 relative overflow-hidden font-sans">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-emerald-500/5 blur-[120px] -z-10 pointer-events-none"></div>
      
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Branding */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center group">
              <img src="./White.png" alt="Logo" className="w-[220px] md:w-[250px]" />
            </Link>
            <p className="text-slate-400 text-sm md:text-base leading-relaxed">
              Ihr Meisterbetrieb für Garten- und Landschaftsbau. Wir verwandeln Ihre grünen Träume in nachhaltige Realität.
            </p>
            <div className="flex gap-4 mt-2">
           {[
  { Icon: Instagram, link: "https://www.instagram.com/galabau_palloshi/" }
].map(({ Icon, link }, i) => (
  <a
    key={i}
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-all border border-white/5"
  >
    <Icon size={18} />  
  </a>
))}

            </div>
          </div>

       {/* Services */}
{/* Services */}
<div className="space-y-8 text-sm md:text-base">
  {serviceCategories.map((cat, i) => (
    <div key={i}>
      <h3 className="text-white font-semibold mb-4 flex items-center gap-2 uppercase tracking-widest text-xs md:text-sm">
        {cat.icon} {cat.title}
      </h3>
      <ul className="space-y-2">
        {cat.items.map((item, j) => (
          <li key={j} className="flex items-center group transition-colors">
            <ChevronRight 
              size={14} 
              className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all text-emerald-500 mr-1" 
            />
            <Link 
              to={`/services/${encodeURIComponent(item)}`} 
              className="hover:text-emerald-400 transition-colors"
            >
              {item}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  ))}
</div>



          {/* Navigation */}
          <div className="text-sm md:text-base">
            <h3 className="text-white font-semibold mb-6 uppercase tracking-widest text-xs md:text-sm">Navigation</h3>
            <ul className="space-y-4 mb-8">
              {[{ name: 'Startseite', path: '/' },
                { name: 'Über uns', path: '/About' },
                { name: 'Galerie', path: '/Project' },
                 { name: 'Leistungen', path: '/Services' },
                { name: 'Häufige Fragen', path: '/Faq' }].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="hover:text-emerald-400 transition-colors font-medium flex items-center text-sm md:text-base">
                    <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="bg-slate-800/50 p-4 rounded-xl border border-white/5">
              <h4 className="text-white text-xs md:text-sm font-semibold mb-1 flex items-center gap-2">
                <Clock size={14} className="text-emerald-500" /> Erreichbarkeit
              </h4>
              <p className="text-slate-400 text-xs md:text-sm tracking-wide">Mo - Fr: 08:00 - 18:00 Uhr</p>
            </div>
          </div>

          {/* Kontakt */}
          <div className="space-y-6 text-sm md:text-base">
            <h3 className="text-white font-semibold uppercase tracking-widest text-xs md:text-sm">Kontakt</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                
              </div>
              <div className="flex items-center gap-3 font-semibold text-white">
                <Phone className="text-emerald-500 shrink-0" size={18} />
                +49 15735547097
              </div>
              <div className="flex items-center gap-3">
                <Mail className="text-emerald-500 shrink-0" size={18} />
                <span className="underline underline-offset-4 decoration-emerald-500/30">palloshi.1@web.de</span>
              </div>
            </div>
            <Link to="/Contact" className="w-full bg-emerald-700 hover:bg-emerald-600 text-white py-4 px-6 rounded-xl font-semibold transition-all flex items-center justify-center gap-2 group shadow-lg shadow-emerald-900/20">
              Angebot anfordern
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>

            <img src="./image.png" alt="Kontakt" className=" rounded-lg object-cover mt-4" />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] md:text-[12px] uppercase tracking-widest text-slate-500 font-medium">
          <div className="flex gap-8">
            <button onClick={() => setModalType('impressum')} className="hover:text-white transition-colors">Impressum</button>
            <button onClick={() => setModalType('datenschutz')} className="hover:text-white transition-colors">Datenschutz</button>
          </div>
          <p className="mt-2 md:mt-0">&copy; {new Date().getFullYear()} Palloshigalabau  </p>
        </div>
      </div>

      {/* Modals */}
      <LegalModal 
        title="Impressum" 
        isOpen={modalType === 'impressum'} 
        onClose={() => setModalType(null)}
      >
        <div className="space-y-4 text-sm md:text-base text-slate-700">
          <p className="font-semibold">Angaben gemäß § 5 TMG</p>
          <p>Palloshigalabau GmbH<br />Musterweg 1<br />12345 Musterstadt</p>
          <p><strong>Vertreten durch:</strong><br />Max Mustermann</p>
          <p><strong>Kontakt:</strong><br />Telefon: +49 15735547097<br />E-Mail: palloshi.1@web.de</p>
        </div>
      </LegalModal>

      <LegalModal 
        title="Datenschutzerklärung" 
        isOpen={modalType === 'datenschutz'} 
        onClose={() => setModalType(null)}
      >
        <div className="space-y-4 text-sm md:text-base text-slate-700">
          <h3 className="font-semibold text-slate-800">1. Datenschutz auf einen Blick</h3>
          <p>Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig.</p>
          <h3 className="font-semibold text-slate-800">2. Datenerfassung</h3>
          <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
          <p>Ihre Daten werden erhoben, wenn Sie diese z. B. in ein Kontaktformular eingeben.</p>
        </div>
      </LegalModal>
    </footer>
  );
};

export default Footer;
